import ReactApexChart from "react-apexcharts";

const SalesPieChart = ({ states }) => {
    const chartData = states?.second_chart_data || {};

    const labels = Object.keys(chartData);

    const series = labels.map(
        key => parseFloat(chartData[key]?.percent) || 0
    );

    const options = {
        chart: {
            width: "100%",
            type: "pie",
        },
        labels,
        colors: ['#cd7f32', '#ffd700', '#c0c0c0', '#b9f2ff'], // optional (can also make dynamic)
        dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(2)}%`,
        },
    };

    return (
        <ReactApexChart options={options} series={series} type="pie" width="100%" />
    );
};

export default SalesPieChart;